exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__wfpContainerFixed___1vEb0{height:100%;padding:0 !important;min-width:768px;position:relative}.styles__wfpMainContainer___2hV1F{flex-wrap:nowrap}.styles__evaluationStatusButton___2OZ6o{padding:1.25rem 0 .75rem}@media(min-width: 1024px){.styles__evaluationStatusButton___2OZ6o{display:none}}", ""]);

// Exports
exports.locals = {
	"wfpContainerFixed": "styles__wfpContainerFixed___1vEb0",
	"wfpMainContainer": "styles__wfpMainContainer___2hV1F",
	"evaluationStatusButton": "styles__evaluationStatusButton___2OZ6o"
};